<template>
  <div>
    <el-table :data="list.value" border height="650" style="margin-top: 20px" row-key="id">
      <el-table-column prop="id" label="ID" width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="name" label="策略名称" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="popupTypeName" label="弹窗类型" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="channelInfo" label="渠道配置" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="versionRangeInfo" label="版本配置" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="uidFilterInfo" label="UID" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="showJumpButtonName" label="展示跳转" width="100">
        <template slot-scope="{ row }">
          <el-tag v-if="row.showJumpButton === 1" type="success">展示</el-tag>
          <el-tag v-else-if="row.showJumpButton === 0" type="info">不展示</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="showJumpName" label="关联跳转" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="showReservedButtonName" label="展示预留" width="100">
        <template slot-scope="{ row }">
          <el-tag v-if="row.showReservedButton === 1" type="success">展示</el-tag>
          <el-tag v-else-if="row.showReservedButton === 0" type="info">不展示</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="按钮标题" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="statusName" label="状态" width="80">
        <template slot-scope="{ row }">
          <el-tag v-if="row.status === 1" type="success">生效</el-tag>
          <el-tag v-else-if="row.status === 0" type="danger">失效</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="160"></el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="{ row }">
          <el-button v-auth="'UPGRADE_POPUP_LOG'" type="text" size="small" @click="viewLog(row)">日志</el-button>
          <el-button v-auth="'UPGRADE_POPUP_EDIT'" type="text" size="small" @click="edit(row.id)">编辑</el-button>
          <el-button v-auth="'UPGRADE_POPUP_DEL'" type="text" size="small" @click="del(row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页组件 -->
    <ElementPagination 
      style="margin-bottom: 20px" 
      :current-page="searchParams.current" 
      :page-size="searchParams.size"
      :total="searchParams.total" 
      :page-sizes="[10, 20, 30, 40, 50]" 
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange" 
    />
    
    <!-- 操作日志 -->
    <OptionLog 
      ref="optionLog" 
      :columnConfig="optionLogColumn" 
      @reload="reloadOpt" 
      :closeBtn="false">
    </OptionLog>
    
    <EditDialog ref="editDialog" @reload="getList"></EditDialog>
  </div>
</template>

<script>
import { deleteUpgradePopup, getUpgradePopupList, getUpgradePopupLogList } from "@/api/apps/upgradePopupManage";
import ElementPagination from "@/components/ElementPagination";
import Message from "@/components/Message";
import OptionLog from "@/components/OptionsLog/optionLog.vue";
import EditDialog from "./edit.vue";

export default {
  name: "UpgradePopupManageTable",
  inject: ["list", "searchParams"],
  components: {
    ElementPagination,
    EditDialog,
    OptionLog
  },

  data() {
    return {
      /** 操作日志列配置 */
      optionLogColumn: [
        { prop: "operateTime", label: "操作时间", width: "160" },
        { prop: "operator", label: "操作人", width: "120" },
        { prop: "typeName", label: "操作类型", width: "120" }
      ]
    };
  },

  mounted() {
    // 组件加载时获取数据
    this.getList();
  },

  methods: {
    /** 获取列表 */
    async getList() {
      try {
        const params = {
          current: this.searchParams.current,
          size: this.searchParams.size,
          // 添加搜索条件
          name: this.searchParams.name,
          channelId: this.searchParams.channelId,
          showJumpId: this.searchParams.showJumpId,
          showJumpButton: this.searchParams.showJumpButton,
          showReservedButton: this.searchParams.showReservedButton,
          status: this.searchParams.status
        };
        const { data } = await getUpgradePopupList(params);
        this.list.value = data.data.records;
        this.searchParams.total = data.data.total;
      } catch (error) {
        console.error("获取列表失败", error);
      }
    },
    
    /** 拉取并显示操作日志 */
    async fetchAndShowLogs(subjectId) {
      try {
        const logPager = this.$refs.optionLog.searchParams || { current: 1, size: 10 };
        const { data } = await getUpgradePopupLogList({
          current: logPager.current,
          size: logPager.size,
          module: 2,
          subjectId
        });
        const records = (data && data.data && data.data.records) || [];
        const total = (data && data.data && data.data.total) || 0;
        if (this.$refs.optionLog && this.$refs.optionLog.searchParams) {
          this.$refs.optionLog.searchParams.total = total;
        }
        // 按组件约定：show(list, subjectId)
        this.$refs.optionLog.show(records, subjectId);
      } catch (error) {
        console.error("获取操作日志失败", error);
      }
    },
    
    /** 查看日志 */
    viewLog(row) {
      this.fetchAndShowLogs(row.id);
    },
    
    /** 编辑 */
    edit(id) {
      this.$refs.editDialog.show('edit', { id });
    },
    
    /** 删除 */
    del(id) {
      this.$confirm('确认删除该升级弹窗策略吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteUpgradePopup(id);
          Message.success('删除成功');
          this.getList();
        } catch (error) {
          Message.error('删除失败');
        }
      }).catch(() => {});
    },
    
    /** 分页大小改变 */
    handleSizeChange(size) {
      this.searchParams.size = size;
      this.searchParams.current = 1;
      this.getList();
    },
    
    /** 当前页改变 */
    handleCurrentChange(current) {
      this.searchParams.current = current;
      this.getList();
    },
    
    /** 刷新操作日志（来自OptionLog分页变化） */
    reloadOpt(subjectId) {
      if (!subjectId) return;
      this.fetchAndShowLogs(subjectId);
    }
  },
};
</script>

<style lang="scss" scoped>
</style> 